<template>
    <div>
        <!-- 子组件 -->
        <template v-for="(item) in menuData">
            <el-submenu v-if="item.children.length" :key="item.code" :index="item.code" :class="[`level${item.level}`, 'itemLevel1']">
                  <!-- <span :title="item.enName">{{item.enName}}</span> -->
                  <!-- <el-popover
                    placement="top-start"
                    title="标题"
                    width="200"
                    trigger="hover"
                    content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。"> -->
                    <!-- <el-button slot="reference">hover 激活</el-button> -->
                    <template slot="title">
                        <span slot="title" :title="item.enName">{{item.abbr}}</span>
                    </template>
                <!-- </el-popover> -->
                
                <el-menu-item-group class="menu-item-group" :style="{color: thisOpenMenuItem == item.code ? '#ff0' : ''}" :class="`level${item.level}`">
                    <MenuTree :menuData="item.children"></MenuTree>
                </el-menu-item-group>
            </el-submenu>
            <el-menu-item v-else :key="item.code" :index="item.code" :class="[defaultActiveIndex == item.code ? 'menuCurrent' : '', `level${item.level}`, 'itemLevel']">
                <!-- <el-popover
                    placement="top-start"
                    title="标题"
                    width="200"
                    trigger="hover"
                    content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。"> -->
                    <!-- <el-button slot="reference">hover 激活</el-button> -->
                    <span slot="title" :title="item.enName">{{item.abbr}}</span>
                <!-- </el-popover> -->
            </el-menu-item>
        </template>
    </div>
</template>

<script> 
  export default {
    props: ['menuData', 'defaultActiveIndex', 'thisOpenMenuItem'],
    name: 'MenuTree',

    data(){
        return {}
    },
    methods: {
        menuClick(item){
            this.$emit('menuClick',item)
        },
        clickIcon(event){
            console.log('clickIcon', event)
        }
    }
  }
</script>